module.exports = __webpack_public_path__ + "img/logo.32e28930.png";